<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            collapseObject: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.contract.contract.item.allocations.sites
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for(let i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();}, 10)
                }
            } else {
                for(let i = 0; i < this.collapseObject.length; i++) {
                    this.collapseObject[i].collapse = !(i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('site_' + obj.siteIndex).scrollIntoView();}, 10)
                }
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-allocation">
        <div class="contract-form-allocation__content">
            <div class="contract-form-allocation__header">
                <div class="contract-form-allocation__heading">
                    {{ $t('contract.form.allocations.header.heading') }}
                </div>
            </div>
            <div class="contract-form-allocation__body">
                <div class="contract-form-allocation__items">
                    <div v-for="(site, siteIndex) in sites" :id="'site_' + siteIndex" :key="'site_' + siteIndex" class="contract-form-allocation__item contract-form-allocation__item-site">
                        <div :class="{'contract-form-allocation__item-header--collapsed': collapseObject[siteIndex].collapse}" class="contract-form-allocation__item-header" @click="collapse({siteIndex: siteIndex})">
                            {{ site.name }}
                        </div>
                        <div v-if="!collapseObject[siteIndex].collapse" >
                            <div v-for="(accommodation, accommodationIndex) in site.accommodations" :id="'accommodation_' + accommodationIndex" :key="'accommodation_' + accommodationIndex" class="contract-form-allocation__item contract-form-allocation__item-accommodation">
                                <div :class="{'contract-form-allocation__item-label--collapsed': collapseObject[siteIndex].accommodations[accommodationIndex]}" class="contract-form-allocation__item-label" @click="collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})">
                                    {{ accommodation.name }}
                                </div>
                                <div v-if="!collapseObject[siteIndex].accommodations[accommodationIndex]" >
                                    <div v-for="(period, index) in accommodation.periods" :key="'arrival_' + index" class="contract-form-allocation__item contract-form-allocation__accommodation-row">
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.startDate}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.startDate') }}</div>
                                            <div v-if="period.startDate" class="contract-form-allocation__item-data">{{ period.startDate | moment('DD/MM/YYYY') }}</div>
                                            <div v-if="!period.startDate" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.endDate}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.endDate') }}</div>
                                            <div v-if="period.endDate" class="contract-form-allocation__item-data">{{ period.endDate | moment('DD/MM/YYYY') }}</div>
                                            <div v-if="!period.endDate" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.type}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.type.label') }}</div>
                                            <div v-if="period.type" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.type.' + period.type) }}</div>
                                            <div v-if="!period.type" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.units}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.units') }}</div>
                                            <div v-if="period.units" class="contract-form-allocation__item-data">{{ period.units }}</div>
                                            <div v-if="!period.units" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.releaseDate}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.releaseDate') }}</div>
                                            <div v-if="period.releaseDate" class="contract-form-allocation__item-data">{{ period.releaseDate | moment('DD/MM/YYYY') }}</div>
                                            <div v-if="!period.releaseDate" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.releaseDays}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.releaseDays') }}</div>
                                            <div v-if="period.releaseDays" class="contract-form-allocation__item-data">{{ period.releaseDays }}</div>
                                            <div v-if="!period.releaseDays" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                        <div :class="{'contract-form-allocation__row-item--inactive' : !period.releaseType}" class="contract-form-allocation__row-item">
                                            <div class="contract-form-allocation__row-label">{{ $t('contract.form.allocations.releaseType') }}</div>
                                            <div v-if="period.releaseType" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.type.' + period.releaseType) }}</div>
                                            <div v-if="!period.releaseType" class="contract-form-allocation__item-data">{{ $t('contract.form.allocations.noData') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sites.length === 0" class="contract-form-site__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">{{ $t('contract.form.allocations.noContent') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormAllocation/ContractFormAllocation.vue